<template>
  <div v-if="open" class="modal-overlay">
    <div class="modal-backdrop" @click="onClose"></div>
    <div class="modal-container">
      <!-- Header -->
      <div class="modal-header">
        <div class="header-content">
          <div class="header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 class="modal-title">{{ t('integracao.contextModalTitle') }}</h3>
            <p class="modal-subtitle">{{ t('integracao.contextModalSubtitle') }}</p>
          </div>
        </div>
        <button @click="onClose" class="close-button">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <!-- Actions Bar -->
        <div class="actions-bar">
          <div class="info-section">
            <svg xmlns="http://www.w3.org/2000/svg" class="info-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <div class="info-title">{{ t('integracao.customContextTitle') }}</div>
              <div class="info-text">{{ t('integracao.customContextHint') }}</div>
            </div>
          </div>
          <button @click="addItem" class="add-button">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            {{ t('integracao.addItem') }}
          </button>
        </div>

        <!-- Items List -->
        <div class="items-container">
          <draggable v-model="items" item-key="id" handle=".drag-handle" @end="saveOrder" class="items-list">
            <template #item="{ element, index }">
              <div class="context-item">
                <div class="item-header">
                  <div class="item-header-left">
                    <span class="drag-handle">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16" />
                      </svg>
                    </span>
                    <span class="item-number">#{{ index + 1 }}</span>
                    <input 
                      v-model="element.titulo" 
                      :placeholder="t('integracao.contextTitlePlaceholder')" 
                      class="item-title-input"
                    />
                  </div>
                  <div class="item-actions">
                    <button @click="saveItem(element)" class="btn-save">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                      {{ t('common.save') }}
                    </button>
                    <button @click="removeItem(element)" class="btn-delete">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                      {{ t('common.delete') }}
                    </button>
                  </div>
                </div>
                <div class="item-body">
                  <div class="form-group full">
                    <label class="form-label">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
                      </svg>
                      {{ t('integracao.descriptionContent') }}
                    </label>
                    <textarea 
                      v-model="element.descricao" 
                      rows="4" 
                      :placeholder="t('integracao.descriptionPlaceholder')"
                      class="form-textarea"
                    ></textarea>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        {{ t('integracao.imageUrl') }}
                      </label>
                      <input 
                        v-model="element.imageUrl" 
                        :placeholder="t('integracao.imageUrlPlaceholder')"
                        class="form-input"
                      />
                    </div>
                    <div class="form-group">
                      <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                        </svg>
                        {{ t('integracao.linksLabel') }}
                      </label>
                      <textarea 
                        v-model="element.links" 
                        rows="2" 
                        :placeholder="t('integracao.linksPlaceholder')"
                        class="form-textarea"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </draggable>
          
          <div v-if="!items || items.length === 0" class="empty-state">
            <svg xmlns="http://www.w3.org/2000/svg" class="empty-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <h4 class="empty-title">{{ t('integracao.emptyContextTitle') }}</h4>
            <p class="empty-text">{{ t('integracao.emptyContextText') }}</p>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <div class="footer-info">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
          </svg>
          {{ t('integracao.reorderHint') }}
        </div>
        <button @click="onClose" class="footer-close-button">{{ t('common.close') }}</button>
      </div>
    </div>
  </div>
  
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '@/services/api'
import Swal from 'sweetalert2'
import draggable from 'vuedraggable'

export default {
  name: 'AIContextModal',
  components: { draggable },
  props: {
    workspaceId: { type: Number, required: true },
    open: { type: Boolean, default: false }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const { t } = useI18n()
    const items = ref([])

    const load = async () => {
      try {
        const { data } = await api.get(`/ai/workspace/${props.workspaceId}/context`)
        items.value = (data || []).map((d, idx) => ({ ...d }))
      } catch (e) {
        await Swal.fire({ icon: 'error', title: t('integracao.swal.error'), text: t('integracao.swal.contextLoadError') })
      }
    }

    const onClose = () => emit('close')

    const addItem = async () => {
      const novo = { titulo: 'Novo item', descricao: '', imageUrl: '', links: '', ordem: (items.value?.length || 0) + 1 }
      try {
        const { data } = await api.post(`/ai/workspace/${props.workspaceId}/context`, novo)
        items.value.push(data)
        await Swal.fire({ icon: 'success', title: t('integracao.swal.created'), timer: 1200, showConfirmButton: false })
      } catch (e) {
        await Swal.fire({ icon: 'error', title: t('integracao.swal.error'), text: t('integracao.swal.createError') })
      }
    }

    const saveItem = async (it) => {
      try {
        const { data } = await api.put(`/ai/workspace/${props.workspaceId}/context/${it.id}`, it)
        // Atualiza local
        const i = items.value.findIndex(x => x.id === it.id)
        if (i >= 0) items.value[i] = data
        await Swal.fire({ icon: 'success', title: t('integracao.swal.saved'), timer: 1000, showConfirmButton: false })
      } catch (e) {
        await Swal.fire({ icon: 'error', title: t('integracao.swal.error'), text: t('integracao.swal.saveError') })
      }
    }

    const removeItem = async (it) => {
      const conf = await Swal.fire({ icon: 'warning', title: t('integracao.swal.deleteItemTitle'), showCancelButton: true, confirmButtonText: t('integracao.swal.confirmDelete'), cancelButtonText: t('common.cancel') })
      if (!conf.isConfirmed) return
      try {
        await api.delete(`/ai/workspace/${props.workspaceId}/context/${it.id}`)
        items.value = items.value.filter(x => x.id !== it.id)
        await Swal.fire({ icon: 'success', title: t('integracao.swal.deleted'), timer: 900, showConfirmButton: false })
      } catch (e) {
        await Swal.fire({ icon: 'error', title: t('integracao.swal.error'), text: t('integracao.swal.deleteError') })
      }
    }

    const saveOrder = async () => {
      // Persiste nova ordem: reindexa e chama PUT em cada item alterado
      for (let i = 0; i < items.value.length; i++) {
        const it = items.value[i]
        if (it.ordem !== i + 1) {
          try {
            await api.put(`/ai/workspace/${props.workspaceId}/context/${it.id}`, { ...it, ordem: i + 1 })
            it.ordem = i + 1
          } catch (e) {
            // ignora e segue
          }
        }
      }
      await Swal.fire({ icon: 'success', title: t('integracao.swal.orderUpdated'), timer: 1000, showConfirmButton: false })
    }

    watch(() => props.open, (nv) => { if (nv) load() })
    onMounted(() => { if (props.open) load() })

    return { t, items, onClose, addItem, saveItem, removeItem, saveOrder }
  }
}
</script>

<style scoped>
/* Modal Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

/* Modal Container - 80% da tela */
.modal-container {
  position: relative;
  width: 85%;
  max-width: 1400px;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dark .modal-container {
  background: #1f2937;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
}

/* Header */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  border-bottom: 2px solid #e5e7eb;
  background: linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%);
}

.dark .modal-header {
  background: linear-gradient(135deg, #581c87 0%, #7c3aed 100%);
  border-color: rgba(255, 255, 255, 0.1);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.modal-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  margin: 4px 0 0;
}

.close-button {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}

/* Body */
.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px 32px;
  background: #f9fafb;
}

.dark .modal-body {
  background: #111827;
}

/* Actions Bar */
.actions-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 24px;
}

.dark .actions-bar {
  background: #1f2937;
  border-color: #374151;
}

.info-section {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.info-icon {
  width: 20px;
  height: 20px;
  color: #6d28d9;
  flex-shrink: 0;
  margin-top: 2px;
}

.dark .info-icon {
  color: #8b5cf6;
}

.info-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 4px;
}

.dark .info-title {
  color: #f3f4f6;
}

.info-text {
  font-size: 13px;
  color: #6b7280;
}

.dark .info-text {
  color: #9ca3af;
}

.add-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(109, 40, 217, 0.3);
}

.add-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(109, 40, 217, 0.4);
}

/* Items Container */
.items-container {
  min-height: 200px;
}

.items-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Context Item */
.context-item {
  background: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s;
}

.context-item:hover {
  border-color: #6d28d9;
  box-shadow: 0 4px 12px rgba(109, 40, 217, 0.1);
}

.dark .context-item {
  background: #1f2937;
  border-color: #374151;
}

.dark .context-item:hover {
  border-color: #8b5cf6;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.2);
}

.item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.dark .item-header {
  background: #111827;
  border-color: #374151;
}

.item-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.drag-handle {
  width: 32px;
  height: 32px;
  background: #e5e7eb;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  cursor: grab;
  transition: all 0.2s;
}

.drag-handle:active {
  cursor: grabbing;
}

.drag-handle:hover {
  background: #6d28d9;
  color: #ffffff;
}

.dark .drag-handle {
  background: #374151;
  color: #9ca3af;
}

.dark .drag-handle:hover {
  background: #8b5cf6;
  color: #ffffff;
}

.item-number {
  font-size: 12px;
  font-weight: 700;
  color: #6d28d9;
  background: rgba(109, 40, 217, 0.1);
  padding: 4px 10px;
  border-radius: 6px;
}

.dark .item-number {
  color: #8b5cf6;
  background: rgba(139, 92, 246, 0.2);
}

.item-title-input {
  flex: 1;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  outline: none;
  transition: all 0.2s;
}

.item-title-input:focus {
  border-color: #6d28d9;
  box-shadow: 0 0 0 3px rgba(109, 40, 217, 0.1);
}

.dark .item-title-input {
  background: #374151;
  border-color: #4b5563;
  color: #f3f4f6;
}

.dark .item-title-input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.2);
}

.item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-save,
.btn-delete {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-save {
  background: #10b981;
  color: #ffffff;
}

.btn-save:hover {
  background: #059669;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);
}

.btn-delete {
  background: #ef4444;
  color: #ffffff;
}

.btn-delete:hover {
  background: #dc2626;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.3);
}

/* Item Body */
.item-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group.full {
  grid-column: 1 / -1;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.dark .form-label {
  color: #d1d5db;
}

.form-label svg {
  color: #6d28d9;
}

.dark .form-label svg {
  color: #8b5cf6;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 10px 12px;
  background: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  outline: none;
  transition: all 0.2s;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus {
  border-color: #6d28d9;
  box-shadow: 0 0 0 3px rgba(109, 40, 217, 0.1);
}

.dark .form-input,
.dark .form-textarea {
  background: #374151;
  border-color: #4b5563;
  color: #f3f4f6;
}

.dark .form-input:focus,
.dark .form-textarea:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.2);
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-icon {
  width: 64px;
  height: 64px;
  color: #d1d5db;
  margin-bottom: 16px;
}

.dark .empty-icon {
  color: #4b5563;
}

.empty-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.dark .empty-title {
  color: #f3f4f6;
}

.empty-text {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.dark .empty-text {
  color: #9ca3af;
}

/* Footer */
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 32px;
  border-top: 2px solid #e5e7eb;
  background: #ffffff;
}

.dark .modal-footer {
  background: #1f2937;
  border-color: #374151;
}

.footer-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;
}

.dark .footer-info {
  color: #9ca3af;
}

.footer-info svg {
  color: #6d28d9;
}

.dark .footer-info svg {
  color: #8b5cf6;
}

.footer-close-button {
  padding: 10px 24px;
  background: #e5e7eb;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
}

.footer-close-button:hover {
  background: #d1d5db;
}

.dark .footer-close-button {
  background: #374151;
  color: #d1d5db;
}

.dark .footer-close-button:hover {
  background: #4b5563;
}

/* Utilidades */
.w-4 { width: 16px; }
.h-4 { height: 16px; }
.w-5 { width: 20px; }
.h-5 { height: 20px; }
.w-6 { width: 24px; }
.h-6 { height: 24px; }
</style>


